import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { Grid, Form, Header } from 'semantic-ui-react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  RangeDatePickerField,
  ReduxFormButtonGroup,
  DatePickerField,
  SelectField,
} from 'Common/SemanticWrapper';
import { SCHOOL_SITE_ORDER_FORM_NAME } from 'Common/FormEnum';
import { SchoolSiteOrderFieldEnum as Fields } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { rangeDateValidator } from 'Common/FormHelper';
import { TitledCard } from 'Components/';
import SelectSitesTableReduxForm from 'Common/SelectSitesTableReduxForm';
import * as SiteSelectors from 'State/sites/selectors';
import {
  selectVendorOptions,
  getVendorDataLoading,
} from 'State/filters/selectors';
import * as ProdRecordHelpers from 'Pages/manageproduction/helpers/productionRecord';

import * as SchoolSiteOrderSelectors from '../state/selectors';
import { IS_DELIVER_ON_SERVING_DATE_OPTIONS } from '../helpers/Constants';

const gridAlignmentStyles = {
  marginLeft: 6,
};

class SchoolSiteOrderForm extends Component {
  static propTypes = {
    orderType: PropTypes.number,
    vendorOptions: PropTypes.array,
  };

  static defaultProps = {
    vendorOptions: [],
  };

  get prodRecordTableColumns() {
    const { sitesMap } = this.props;

    return ProdRecordHelpers.createProdRecordTableColumns({ sitesMap });
  }

  render() {
    const {
      isDeliverOnServingDate,
      loadingVendors,
      vendorOptions,
    } = this.props;

    const showDatePicker = !isDeliverOnServingDate;

    return (
      <Form>
        <Grid>
          <Grid.Row style={gridAlignmentStyles}>
            <Grid.Column width={5}>
              <Header as="h5">SELECT DATE RANGE</Header>
            </Grid.Column>
            <Grid.Column width={5}>
              <ReduxFormButtonGroup
                options={IS_DELIVER_ON_SERVING_DATE_OPTIONS}
                formName={SCHOOL_SITE_ORDER_FORM_NAME}
                fieldName={Fields.IsDeliverOnServingDate}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{ ...gridAlignmentStyles, marginBottom: 12 }}>
            <Grid.Column width={5}>
              <RangeDatePickerField
                fromName={Fields.StartServingDT}
                fromLabel="From Date"
                toName={Fields.EndServingDT}
                toLabel="To Date"
              />
            </Grid.Column>
            <Grid.Column width={5}>
              {showDatePicker && (
                <Field
                  name={Fields.DeliveryDT}
                  component={DatePickerField}
                  style={{ marginTop: 22 }}
                />
              )}
            </Grid.Column>
            <Grid.Column width={5}>
              <Grid>
                <Grid.Row>
                  <Grid.Column>
                    <Field
                      component={SelectField}
                      options={vendorOptions}
                      loading={loadingVendors}
                      name={Fields.DistributorId}
                      label="Distributor"
                      placeholder="Select a distributor"
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <TitledCard title="Select Sites or Site Groups">
                <Field
                  name={Fields.SiteIds}
                  component={SelectSitesTableReduxForm}
                  fetchAllSites={true}
                />
              </TitledCard>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}

const validate = (values) => {
  const errors = {};
  const rangeErrors = rangeDateValidator(
    values[Fields.StartServingDT],
    values[Fields.EndServingDT],
    {
      granularity: 'day',
      fromName: Fields.StartServingDT,
      toName: Fields.EndServingDT,
      fromLabel: 'From',
      toLabel: 'To',
      dateFormat: DATE_FORMAT_FOR_UI,
      strict: false,
    }
  );

  if (!values[Fields.IsDeliverOnServingDate] && !values[Fields.DeliveryDT]) {
    errors[Fields.DeliveryDT] = 'Field is required.';
  }

  const hasSites =
    Array.isArray(values[Fields.SiteIds]) && values[Fields.SiteIds].length > 0;

  if (!hasSites) {
    errors[Fields.SiteIds] = 'A site is required.';
  }

  return {
    ...errors,
    ...rangeErrors,
  };
};

const mapStateToProps = (state) => ({
  isDeliverOnServingDate: SchoolSiteOrderSelectors.getDeliverOnServingDate(
    state
  ),
  sites: SiteSelectors.getSites(state),
  sitesLoading: SiteSelectors.getSitesLoading(state),
  sitesMap: SiteSelectors.getSitesMap(state),
  vendorOptions: selectVendorOptions(state),
  loadingVendors: getVendorDataLoading(state),
});

SchoolSiteOrderForm = connect(mapStateToProps)(
  reduxForm({
    form: SCHOOL_SITE_ORDER_FORM_NAME,
    destroyOnUnmount: false,
    enableReinitialize: true,
    validate,
  })(SchoolSiteOrderForm)
);

export { SchoolSiteOrderForm };



// WEBPACK FOOTER //
// ./src/pages/schoolsiteorder/components/SchoolSiteOrderForm.js